<template>
  <div id="onlinePaymentPage">
    <NavBar class="overflow-y-hidden" />

        <v-main class="overflow-hidden">
          <div class="has-footer-payments">
            <div class="container-fluid">
              <div v-if="bannerLoading" class="row align-items-center ">
                <div class="col-12 text-center pb-1">
                  <v-skeleton-loader
                      class="mx-auto border"
                      type="image"
                      height="150"
                      width="100%"
                  ></v-skeleton-loader>
                </div>
                <div class="col-6 pt-0 pl-1">
                  <v-skeleton-loader
                      class="mx-auto border"
                      type="image"
                      width="100%"
                      height="150"></v-skeleton-loader>
                </div>
                <div class="col-6 pt-0 pr-1">
                  <v-skeleton-loader
                      class="mx-auto border"
                      type="image"  width="100%"
                      height="150"></v-skeleton-loader>
                </div>
              </div>
              <div v-else-if="banners.length >0" class="row">
                <div class="col-12 p-1  col-md-8">
                  <v-carousel
                      :continuous="false"
                      :cycle="true"
                      :height="$vuetify.breakpoint.xs ? 220 : 400"
                      :show-arrows="false"
                      class="carousel-dots banner-carousel rounded-11px"
                      dark
                      delimiter-icon="fa-solid fa-circle-small white--text"
                      hide-delimiter-background>
                    <v-carousel-item
                        v-for="(slide, i) in banners"
                        :key="i">
                      <div>
                        <div
                            class="fill-height row justify-content-center align-items-center">
                          <v-img  @click="$openLink(slide.Link)" :src="$replaceHttps(slide.FileUrl)" :lazy-src="$replaceHttps(slide.FileUrl)" class="col-12" contain>
                          </v-img>
                        </div>
                      </div>
                    </v-carousel-item>
                  </v-carousel>
                </div>
                <div v-if="!bannerLoading" class="col-12 col-md-4 pt-0">
                  <div class="row">
                    <div class="col-6 col-md-12 p-1 pt-md-2">
                      <v-img  @click="$openLink(bannerRightLink)" :height="$vuetify.breakpoint.xs ? 150 : 194" :src="$replaceHttps(bannerRight)"
                             class="rounded-lg" :lazy-src="$replaceHttps(bannerRight)"></v-img>
                    </div>
                    <div class="col-6 col-md-12 p-1">
                      <v-img  @click="$openLink(bannerLeftLink)" :height="$vuetify.breakpoint.xs ? 150 : 194" :src="$replaceHttps(bannerLeft)"
                             class="rounded-lg" :lazy-src="$replaceHttps(bannerLeft)"></v-img>
                    </div>
                  </div>
                </div>

              </div>

              <ProductsCarousel :dataLoading="specialOffersLoading" :products="specialOffersProducts"
                                :title="'پیشنهاد های شگفت انگیز'" :isOnline="'true'" :type="'پیشنهاد_شگفت_انگیز'"/>
              <ProductsOrStoreCategories :categories="productsCategories" :data-loading="productsCategoriesLoading"
                                         :title="'دسته بندی محصولات'" :isOnline="'true'"/>
              <Stores :data-loading="bestStoresLoading" :stores="bestStores" :title="' فروشگاه های برتر'" :isOnline="'online'"  :type="'true'"/>
              <ProductsCarousel :dataLoading="dayOffersLoading" :products="dayOffers"
                                :title="'پیشنهادهای روز'" :type="'پیشنهاد_روز'"  :isOnline="'true'"/>
              <GridTemplate :is-online="'true'"  :type="'جدیدترین_ها'" :data-loading="latestProductsLoading" :items="latestProducts" :title="'جدیدترین محصولات'"/>
              <div class="row my-2">
                <h1 class="col-8 primary-text">پرفروش ترین محصولات</h1>
                <router-link :to="{path:'ProductsList',query:{isOnline:'true',type:'بیشترین_فروش'}}" class="col-4 text-left "><span class="primary-text ml-2 pointer">MORE</span> <i
                    class="fa-solid fa-arrow-left fa-lg pointer"></i></router-link>
              </div>
              <div v-if="bestselling.length >0" >
                <VueSlickCarousel v-bind="settings" :arrows="true" >
                  <div v-for="(item,i) in bestselling" :key="i"  class="">
                    <ProductListsCard :item="item" />
                  </div>
                </VueSlickCarousel>
              </div>
              <GridTemplate :is-online="'true'" :data-loading="firstGridProductsLoading" :items="firstGridProducts" :title="firstGridProductsTitle"/>
              <router-link to="LoginRegister" class="row  px-1 my-2 d-flex">
                <div class="col-6 p-3 bg-white rounded-r-lg">
                  <i class="fa-solid fa-bag-shopping font16px pointer"></i>
                  <span class="mr-2 font16px pointer">فروشگاه بسازید</span>
                </div>
                <div class="col-6 p-3 bg-white rounded-l-lg text-left">
                  <span class="font16px pointer"><i class="fa-solid fa-user-plus font16px"></i> خرید کنید/نقد کنید</span>
                </div>
              </router-link>
              <GridTemplate :is-online="'true'"  :data-loading="secondGridProductsLoading" :items="secondGridProducts" :title="secondGridProductsTitle"/>
              <div class="row my-3">
                <div v-if="!bannerLoading" class="col-12 p-1">
                  <v-carousel
                      :continuous="false"
                      :cycle="true"
                      height="auto"
                      :show-arrows="false"
                      class="banner-carousel carousel-dots rounded-lg"
                      dark
                      delimiter-icon="fa-solid fa-circle-small white--text"

                      hide-delimiter-background>
                    <v-carousel-item
                        v-for="(slide, i) in downBanners"
                        :key="i">
                      <a :href="slide.Link" target="_blank">
                          <v-img :src="$replaceHttps(slide.FileUrl)"
                                 @click="$openLink(slide.Link)"
                                 :lazy-src="$replaceHttps(slide.FileUrl)">
                          </v-img>
                      </a>

                    </v-carousel-item>
                  </v-carousel>
                </div>
              </div>
              <ContentsCarousel :data-loading="dayNewsLoading" :items="dayNews" :title="'اخبار روز'" :type="1" :isOnline="true"/>
              <articles :data-loading="articlesLoading" :items="articles" :title="'مقاله'" :isOnline="true"/>
              <ContentsCarousel :data-loading="reviewsLoading" :items="reviews" :title="'نقد و بررسی'" :type="2" :isOnline="true"/>
              <h1 class="col-8 primary-text">فروشگاه ها در سراسر ایران</h1>
              <PaymentsHomesMap :markers="markers"/>

            </div>
            <PaymentsFooter :current-page="'home'" :is-in-online-payment="'true'"/>

          </div>
        </v-main>

  </div>
</template>

<script>
import ProductsCarousel from "@/components/ProductsCarousel";
import ProductsOrStoreCategories from "@/components/ProductsOrStoreCategories";
import Stores from "@/components/Stores";
import GridTemplate from "@/components/GridTemplate";
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import ProductListsCard from "@/components/ProductListsCard";
import ContentsCarousel from "@/components/ContentsCarousel";
import Articles from "@/components/Articles";
import PaymentsFooter from "@/components/PaymentsFooter";
import NavBar from "@/components/NavBar";
import PaymentsHomesMap from "@/components/PaymentsHomesMap";


export default {
  name: "OnlinePaymentHome",
  metaInfo: {
    title: 'ایوان خانه- OnlinePayment',
  },
  components: {
    PaymentsHomesMap,
    NavBar,
    PaymentsFooter,
    Articles,
    ContentsCarousel,
    ProductListsCard,
    GridTemplate, Stores, ProductsOrStoreCategories, ProductsCarousel, VueSlickCarousel
  },
  data() {
    return {
      markers: [],
      downBanners: [],
      banners: [],
      bannerLoading: true,
      bannerRight: null,
      bannerLeft: null,
      bannerRightLink: null,
      bannerLeftLink: null,
      specialOffersProducts: [],
      specialOffersLoading: true,
      productsCategories: [],
      productsCategoriesLoading: true,
      bestStores: [],
      bestStoresLoading: true,
      dayOffers: [],
      dayOffersLoading: true,
      latestProducts: [],
      latestProductsLoading: true,
      settings: {
        "infinite": true,
        "speed": 500,
        "rows": 3,
        "dots": false,
        "arrows": true,
        "rtl": false,
        "slidesToShow": 1,
        "initialSlide": 0,

      },
      latestNews: [],
      bestselling: [],
      firstGridProducts: [],
      firstGridProductsLoading: true,
      firstGridProductsTitle:'',
      secondGridProducts: [],
      secondGridProductsLoading: true,
      secondGridProductsTitle:'',
      dayNews: [],
      dayNewsLoading: true,
      articles: [],
      articlesLoading: true,
      reviews: [],
      reviewsLoading: true,
      activeNav:null
    }
  },
  mounted() {
    this.getData()
    this.getSpecialOffers()
    this.getDayOffers()
    this.getLatestProducts()
    this.getBestSellingProducts()
    this.getStoresForMap()


  },
  methods: {

    getData() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchEngine/ShoppingOnlineCenter", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let banners = json.BanerViewModel.filter(x => x.IsActive === true)
            this.banners = banners.filter(x => x.TypeBaner === 2);
            let bannersRight = banners.filter(x => x.TypeBaner === 3);
            this.bannerRight = bannersRight[0].FileUrl;
            this.bannerRightLink = bannersRight[0].Link;
            this.downBanners = banners.filter(x => x.TypeBaner === 5);
            let bannersLeft = banners.filter(x => x.TypeBaner === 4);
            this.bannerLeft = bannersLeft[0].FileUrl;
            this.bannerLeftLink = bannersLeft[0].Link;
            this.bannerLoading = false

            this.productsCategories = json.ProductCategoryViewModel
            this.productsCategoriesLoading = false;


            this.bestStores =json.VendorViewModel.filter(x=>x.IsVipBrand === true)
            this.bestStoresLoading = false;

            let products = json.ProductCategoryViewModel.filter(x => x.IsShowCenterPage === true);
           this.products1 = products[0];
           this.firstGridProductsTitle = products[0].Name
            this.initFirstGridProducts();
            this.products2 = products[1];
            this.secondGridProductsTitle = products[1].Name
            this.initSecondGridProducts();

            let extraExtension = json.ExtraExtensionViewModel.filter(x => x.TypeExtraExtension === 1 && x.IsActive === true)
            this.dayNews = extraExtension.filter(x => x.TypeDefineExtraExtension === 1)
            this.dayNewsLoading = false;

            this.reviews = extraExtension.filter(x => x.TypeDefineExtraExtension === 3)
            this.reviewsLoading = false;

            this.articles = extraExtension.filter(x => x.TypeDefineExtraExtension === 2)
            this.articlesLoading = false;



          })
          .catch(error => console.log('error', error));

    },
    getSpecialOffers() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeVendorProduct", "پیشنهاد_شگفت_انگیز");
      urlencoded.append("IsOnlineVendor", "true");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };


      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            let products = JSON.parse(result);
            for (let i = 0; i < products.length; i++) {
              products[i].tip = products[i].VendorProductTipViewModels[0]

              let voteArr = products[i].VoteViewModel

              let num = voteArr.length
              let sumVote = 0
              for (let j = 0; j < voteArr.length; j++) {
                sumVote += voteArr[j].Rate
              }
              let avg = sumVote / num;
              if (avg > 0) {
                products[i].avgVote = sumVote / num
              } else {
                products[i].avgVote = 0
              }
            }

            this.specialOffersProducts = products
            this.specialOffersLoading = false;
          })
          .catch(error => console.log('error', error));
    },
    getDayOffers() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeVendorProduct", "پیشنهاد_روز");
      urlencoded.append("IsOnlineVendor", "true");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };


      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            let products = JSON.parse(result);
            for (let i = 0; i < products.length; i++) {
              products[i].tip = products[i].VendorProductTipViewModels[0]

              let voteArr = products[i].VoteViewModel

              let num = voteArr.length
              let sumVote = 0
              for (let j = 0; j < voteArr.length; j++) {
                sumVote += voteArr[j].Rate
              }
              let avg = sumVote / num;
              if (avg > 0) {
                products[i].avgVote = sumVote / num
              } else {
                products[i].avgVote = 0
              }
            }

            this.dayOffers =products;
            this.dayOffersLoading = false;
          })
          .catch(error => console.log('error', error));
    },
    getLatestProducts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeVendorProduct", "جدیدترین_ها");
      urlencoded.append("IsOnlineVendor", "true");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };


      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.latestProducts =JSON.parse(result);
            this.latestProductsLoading = false;

          })
          .catch(error => console.log('error', error));
    },
    getBestSellingProducts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeSearchEngineSort", "بیشترین_فروش");
      urlencoded.append("IsOnlineVendor", "true");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };


      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            let products = JSON.parse(result);
            for (let i = 0; i < products.length; i++) {
              products[i].tip = products[i].VendorProductTipViewModels[0]

              let voteArr = products[i].VoteViewModel

              let num = voteArr.length
              let sumVote = 0
              for (let j = 0; j < voteArr.length; j++) {
                sumVote += voteArr[j].Rate
              }
              let avg = sumVote / num;
              if (avg > 0) {
                products[i].avgVote = sumVote / num
              } else {
                products[i].avgVote = 0
              }
            }

            this.bestselling =products

          })
          .catch(error => console.log('error', error));
    },

    initFirstGridProducts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductCategoryID", this.products1.ProductCategoryID);
      urlencoded.append("IsOnlineVendor", "true");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };


      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.firstGridProducts =JSON.parse(result);
            this.firstGridProductsLoading = false;

          })
          .catch(error => console.log('error', error));
    },

    initSecondGridProducts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductCategoryID", this.products2.ProductCategoryID);
      urlencoded.append("IsOnlineVendor", "true");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };


      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.secondGridProducts =JSON.parse(result);
            this.secondGridProductsLoading = false;

          })
          .catch(error => console.log('error', error));
    },
    getStoresForMap(){
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + 'SearchEngine/ShoppingOnlineCenter', requestOptions)
          .then(response => response.text())
          .then(result =>{
            let json = JSON.parse(result);
            let vendors = json.VendorViewModel
            let places = []
            for (let i = 0; i < vendors.length; i++) {
              places.push({
                position: {lat: vendors[i].Latitude, lng: vendors[i].Longitude},
                vendorID: vendors[i].VendorID,
                name: vendors[i].Name,
                description: vendors[i].Description,
                date: vendors[i].ModifiedDate,
                icon:this.$replaceHttps(vendors[i].PictureLogoUrl),
                isVerified:vendors[i].IsVerified,
              })
            }
            this.markers = places
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
  }
}
</script>

<style scoped>

</style>
